import { styled } from '@openeducation/oe-it-themes';
import { rgba } from 'polished';
import React, { memo, ReactNode, useRef } from 'react';
import { useHover } from 'react-native-web-hooks';

export interface SelectDropdownItemProps {
  children: string | ReactNode;
  indicator?: string;
}

export const SelectDropdownItem = ({
  children,
  indicator,
}: SelectDropdownItemProps) => {
  const textRef = useRef(null);
  const isHovered = useHover(textRef);

  return (
    <DropdownItemContainer isHovered={isHovered} ref={textRef}>
      {indicator && (
        <DropdownItemIndicator isHovered={isHovered}>
          {indicator}
        </DropdownItemIndicator>
      )}
      <DropdownItemText isHovered={isHovered}>{children}</DropdownItemText>
    </DropdownItemContainer>
  );
};

type DropdownItemTextType = {
  isHovered: boolean;
};

const DropdownItemContainer = styled.View<DropdownItemTextType>`
  background-color: ${({ theme, isHovered }) =>
    isHovered ? rgba(theme.color.primary, 0.1) : 'transparent'};
  padding: 4px 8px;
  border-radius: 4px;
  flex-direction: row;
`;

const DropdownItemText = styled.Text<DropdownItemTextType>`
  color: ${({ theme, isHovered }) =>
    isHovered ? theme.color.dropdownHoveredTextColor : theme.color.black};
  font-family: ${({ theme, isHovered }) =>
    isHovered ? theme.font.bold.fontFamily : theme.font.regular.fontFamily};
  font-size: 16px;
  line-height: 24px;
`;

const DropdownItemIndicator = styled(DropdownItemText)`
  font-family: ${({ theme }) => theme.font.bold.fontFamily};
  margin-right: 5px;
`;

export default memo(SelectDropdownItem);
